<div *ngIf="bookingInfo" class="my-bookings" [ngClass]="bookingInfo.status">
  <div class="my-bookings__title flex jc-sb ai-c">
    <h6>{{bookingInfo.hotelName}}</h6>
    <span>Total Price: {{bookingInfo.price}}€</span>
  </div>

  <span class="my-bookings__status">{{bookingInfo.status}}</span>

  <div [ngClass]="class" class="my-bookings__summary flex-col gap-1">
    <div class="my-bookings__offers flex ai-c">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
           class="feather feather-map">
        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
        <line x1="8" y1="2" x2="8" y2="18"></line>
        <line x1="16" y1="6" x2="16" y2="22"></line>
      </svg>
      <span class="pl-2">{{bookingInfo.address}}</span>
    </div>

    <div class="flex ai-c flow-wrap">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"
           class="feather feather-calendar">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
      </svg>
      <div class="my-bookings__dates pl-2">
        <!-- <span class="">{{bookingInfo.checkin.day}}</span> -->
        <span class="">{{bookingInfo.checkin.number}} </span>
        <span class="">{{bookingInfo.checkin.month | slice:0:3}} {{bookingInfo.checkin.year}}</span>
      </div>

      <span class="pl-2 pr-1">-</span>

      <div class="my-bookings__dates">
        <!-- <span class="">{{bookingInfo.checkout.day}}</span> -->
        <span class="">{{bookingInfo.checkout.number}} </span>
        <span class="">{{bookingInfo.checkout.month | slice:0:3}} {{bookingInfo.checkout.year}}</span>
      </div>

      <div class="my-bookings__nights pl-2">
        <span>({{bookingInfo.numberOfNights}} nights)</span>
      </div>
    </div>

    <div class="my-bookings__cta-container flex ai-c gap-1 jc-c">
      <button *ngIf="isVisible('voucher')" (click)="openVoucher(bookingInfo)" class="my-bookings__cta" href="#" matTooltip="View Voucher" matTooltipPosition="above" tooltipClass="arrow-down"
              value="View Voucher" type="button" title="View Voucher">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
             class="feather feather-eye">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
      </button>

      <button *ngIf="isVisible('payment')" class="booking-action my-bookings__cta has-tooltip update-payment-details" (click)="togglePaymentDetails()" matTooltip="Update Payment Details"
              matTooltipPosition="above" value="Update Payment Details" type="button" title="Update Payment Details">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
             class="feather feather-credit-card" viewBox="0 0 24 24">
          <rect width="22" height="16" x="1" y="4" rx="2" ry="2" />
          <path d="M1 10h22" />
        </svg>
      </button>

      <button *ngIf="isVisible('cancel') && !paymentVisible" class="my-bookings__cta" (click)="toggleCancelCard()" matTooltip="Cancel Booking" matTooltipPosition="above" value="Cancel Booking" type="button" title="Cancel Booking">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-x">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>

      <button (click)="removeBooking()" class="my-bookings__cta" *ngIf="status === 'cancelled'" matTooltip="Remove Booking" matTooltipPosition="above" value="Remove Booking" type="button" title="Remove Booking">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-x">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
    
    <div class="my-bookings__sub-content">
      <app-payment-details *ngIf="paymentVisible" [visibility]="paymentVisible" [type]="'update-payment-details'" (updateCreditCardDetails)="saveCreditCardInfo($event)"
                           (changeVisibility)="changeVisibility($event)"></app-payment-details>
      <div *ngIf="isCancelVisible()" class="cancel-booking">
        <div class="cancellation-policy" *ngIf="fees">
          <h4>Cancellation Policy</h4>
          <div *ngIf="fees.cancellationFees > 0 else freeSection">
            <span class="cancellation-message">Cancellation fees will apply:</span>
            <span class="cancellation-fee">{{fees.cancellationFees}}€</span>
          </div>
          <ng-template #freeSection>
            <span *ngIf="fees.freeCancellationBefore else simplefree" class="cancellation-message">
              Cancellation before <span>{{freeCancellationBefore}}</span>
            </span>
            <span #simplefree>No cancellation fees</span>
            <span class="cancellation-fee free float-right">FREE</span>
          </ng-template>
        </div>
        <div class="cancellation-actions">
          <button (click)="closeBooking()" class="cancellation-actions--keep">Keep my booking</button>
          <button (click)="cancelBooking()" class="cancellation-actions--cancel">Cancel my booking</button>
        </div>
      </div>
    </div>
  </div>
</div>